import React, { Component } from 'react'
import { Menu, Icon, Loader } from 'semantic-ui-react'
import { withRouter, Link } from 'react-router-dom'
import { connect } from 'react-redux'

import actions from './redux/actions'

import Routes from './Routes'
import './App.css'

class App extends Component {
  componentDidMount () {
    this.props.loadUser()
  }

  render () {
    const childProps = {
      isAuthenticated: this.props.isAuthenticated,
      userHasAuthenticated: this.userHasAuthenticated
    }

    return (
      <div className='App ms-Grid'>
        <header className='App-header'>
          <div className='App-menu'>
            <Menu size='large' borderless fluid>
              <Menu.Item header>
                <Link to='/app' style={{ color: '#fff' }}>
                  <Icon name='left quote' />
                  &nbsp;&nbsp;Transcriptions
                </Link>
              </Menu.Item>

              {this.props.isAuthenticated && this.renderMenuItems()}
            </Menu>
          </div>
        </header>

        <div className='App-content'>
          {this.props.isLoading
            ? <Loader active>Loading</Loader>
            : <Routes childProps={childProps} />}
        </div>
      </div>
    )
  }

  userHasAuthenticated = authenticated => {
    this.setState({ isAuthenticated: authenticated })
  }

  handleLogout = async event => {
    this.props.logout()
    this.props.history.push('/')
  }

  renderMenuItems = () => {
    return [
      <Menu.Item
        key='logout'
        name='logout'
        onClick={this.handleLogout}
        position='right'
      />
    ]
  }

  handleMenuItemClick = (e, { name }) => this.setState({ activeMenuItem: name })
}

const mapStateToProps = state => ({
  isLoading: state.user.isLoading,
  isAuthenticated: state.user.isAuthenticated
})

const mapDispatchToProps = dispatch => ({
  loadUser: () => dispatch(actions.user.load()),
  logout: () => dispatch(actions.user.logout())
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App))



// WEBPACK FOOTER //
// ./src/App.js